import { useProjectNavigate } from '@/cms/hooks/navigations/useProjectNavigate';

// Temporary logic
export const usePageJump = () => {
  const { push, router, replace, pop } = useProjectNavigate();

  const cleanAllSessionInfo = () => {
    sessionStorage.removeItem('page-jump-quote-detail-page');
  };

  /**
   * Quote detail page
   */
  const pushToQuoteDetailPage = (data?: { path: string }) => {
    sessionStorage.setItem('page-jump-quote-detail-page', router.asPath);
    push({ path: data?.path });
  };

  const popQuoteDetailPage = () => {
    const url = sessionStorage.getItem('page-jump-quote-detail-page');
    if (url) {
      sessionStorage.removeItem('page-jump-quote-detail-page');
      replace({ url });
    } else {
      pop();
    }
  };

  return {
    cleanAllSessionInfo,
    pushToQuoteDetailPage,
    popQuoteDetailPage,
  };
};
